/* ===== Rating and reviews spots Sava fills in Shopify (added by convert2.py, not in the local mock) =====
   Sava can replace the rating line and the reviews sections from the theme editor
   (section settings "Rating line under the title" and "Reviews section"; text, HTML or a reviews-app
   snippet). Empty = the mock's own content stays. The mock redraws its pages, so the filled content is put back after
   every redraw. Spots: the rating line (#rating-slot / .hrate / .np-rating) and the reviews area
   (#reviews / .np-reviews). */
(function () {
  var get = function (id) { var t = document.getElementById(id); return t ? t.innerHTML.trim() : ""; };
  var R = get("np-slot-rating"), V = get("np-slot-reviews");
  if (!R && !V) return;
  function put(sel, html) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.getAttribute("data-np") === "1" && el.innerHTML === el._np) return;
      el.innerHTML = html; el._np = el.innerHTML; el.setAttribute("data-np", "1"); el.classList.add("np-on");
    });
  }
  function fill() { if (R) put("#rating-slot,.hrate,.np-rating", R); if (V) put("#reviews,.np-reviews", V); }
  fill();
  var busy = false;
  new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { fill(); busy = false; }); })
    .observe(document.body, { childList: true, subtree: true });
})();
